import {
  OPEN_COLLECTION
} from "../actions/collections";

import _ from "lodash";

let selected_col =null;

export default function(state = selected_col, action) {
  switch (action.type) {
    case OPEN_COLLECTION:
      console.log("RECEIVED OPEN_COLLECTION EVENT");
      selected_col = action.payload
      return action.payload;
    default:
      return state;
  }
}